import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  disabled: "",
  selected: "",
  value: ""
}
const _hoisted_2 = { value: "" }
const _hoisted_3 = ["value"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["value"]

import StrategyBriefHubStepLayout from '@/brief-hub/common/ui/layout/StrategyBriefHubStepLayout.vue';
    import {useBriefStrategyStore} from '@/brief-hub/stores/briefStrategy.store';
    import {computed, ref, watch} from 'vue';
    import IndustryExpertise, {IndustryExpertiseItem} from '@/brief-hub/brief/IndustryExpertise';
    import {pushNotification} from '@malt/joy-entrypoint/src/js/notification';
    import {useGlobalProperties} from '@malt/vue3-use';
    import {StrategyFreelancerIndustryExpertisesBriefRequest} from '@/common/api/api-raw-types';
    import {storeToRefs} from 'pinia';
    import {useBriefAmplitudeEvent} from '@/common/composable/useBriefAmplitudeEvent';
    import {pushVJoySnackbar} from '@maltjoy/core-vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'StrategyBriefFreelancerIndustryExpertises',
  setup(__props) {

    const {$msg, $features} = useGlobalProperties();

    const briefStrategyStore = useBriefStrategyStore();
    const {brief} = storeToRefs(briefStrategyStore);
    const {triggerBriefFunnelStepEnteredAmplitudeEvent} = useBriefAmplitudeEvent();

    const industryExpertises = ref<IndustryExpertise[] | null>(null);
    const businessSectors = computed<IndustryExpertiseItem[] | null>(
        () => industryExpertises.value?.map((industryExpertise) => industryExpertise.businessSector) || null,
    );
    const businessIndustries = ref<IndustryExpertiseItem[] | null>(null);
    const selectedBusinessSector = ref<string>('');
    const selectedBusinessIndustry = ref<string>('');
    const displaySkipButton = computed<boolean>(() => !selectedBusinessIndustry.value);

    async function init() {
        if (brief.value) {
            const [data, error] = await brief.value.getIndustryExpertises();
            if (error || !data) {
                pushVJoySnackbar({
                    props: {
                        message: $msg('customer.brief.error.unknown'),
                        level: 'error',
                    },
                });
            } else {
                industryExpertises.value = data;
                selectedBusinessSector.value = briefStrategyStore.briefStrategyIndustryExpertises.businessSectorHumanId;
                selectedBusinessIndustry.value = briefStrategyStore.briefStrategyIndustryExpertises.businessIndustryHumanId;
            }
        }
        triggerBriefFunnelStepEnteredAmplitudeEvent('industry-expertises', 3);
    }

    init();

    watch(selectedBusinessSector, () => {
        if (selectedBusinessSector.value) {
            businessIndustries.value =
                industryExpertises.value?.find((industryExpertise) => industryExpertise.businessSector.humanId === selectedBusinessSector.value)
                    ?.businessIndustries || null;
        } else {
            selectedBusinessIndustry.value = '';
        }
    });

    watch(
        selectedBusinessIndustry,
        () => {
            const payload: StrategyFreelancerIndustryExpertisesBriefRequest = {
                industryExpertises:
                    selectedBusinessSector.value && selectedBusinessIndustry.value
                        ? [
                              {
                                  businessSectorHumanId: selectedBusinessSector.value,
                                  businessIndustryHumanId: selectedBusinessIndustry.value,
                              },
                          ]
                        : [],
            };
            briefStrategyStore.updatePayload({type: 'StrategyFreelancerIndustryExpertisesBriefRequest', payload: payload});
        },
        {immediate: true},
    );

return (_ctx: any,_cache: any) => {
  const _component_VJoySelect = _resolveComponent("VJoySelect")!
  const _component_VJoyWrapper = _resolveComponent("VJoyWrapper")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(StrategyBriefHubStepLayout, { "display-skip-button": displaySkipButton.value }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref($msg)('customer.brief.exec.form.industry.expertise.title')), 1)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_VJoyWrapper, {
          direction: "column",
          align: "stretch",
          "no-margin": ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              (_openBlock(), _createBlock(_component_VJoySelect, {
                id: "business-sector",
                key: selectedBusinessSector.value,
                modelValue: selectedBusinessSector.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedBusinessSector).value = $event)),
                "data-testid": "brief-strategy-business-sector",
                label: _unref($msg)('customer.brief.exec.form.industry.expertise.business.sector.label')
              }, {
                default: _withCtx(() => [
                  _createElementVNode("option", _hoisted_1, _toDisplayString(_unref($msg)('customer.brief.exec.form.industry.expertise.default')), 1),
                  _createElementVNode("option", _hoisted_2, _toDisplayString(_unref($msg)('customer.brief.exec.form.industry.expertise.no.value')), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(businessSectors.value, (businessSector) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: businessSector.humanId,
                      value: businessSector.humanId
                    }, _toDisplayString(businessSector.translation), 9, _hoisted_3))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "label"]))
            ]),
            _createVNode(_Transition, { name: "slide-fade" }, {
              default: _withCtx(() => [
                (selectedBusinessSector.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      (_openBlock(), _createBlock(_component_VJoySelect, {
                        id: "business-industry",
                        key: selectedBusinessSector.value,
                        modelValue: selectedBusinessIndustry.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedBusinessIndustry).value = $event)),
                        "data-testid": "brief-strategy-business-industry",
                        label: _unref($msg)('customer.brief.exec.form.industry.expertise.business.industry.label')
                      }, {
                        default: _withCtx(() => [
                          _cache[2] || (_cache[2] = _createElementVNode("option", {
                            disabled: "",
                            value: "",
                            selected: ""
                          }, "-", -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(businessIndustries.value, (businessIndustry) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: businessIndustry.humanId,
                              value: businessIndustry.humanId
                            }, _toDisplayString(businessIndustry.translation), 9, _hoisted_5))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "label"]))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["display-skip-button"])
  ]))
}
}

})